// import firebase from "firebase/app";
// import "firebase/auth";
// import "firebase/database";

// import { firebaseConfig } from "constants/defaultValues";

// firebase.initializeApp(firebaseConfig);

// const auth = firebase.auth();
// const database = firebase.database();

// export { auth, database };



import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";

import { firebaseConfig } from "constants/defaultValues";

// Initialize Firebase app
const app = initializeApp(firebaseConfig);

// Get Firebase services
const auth = getAuth(app);
const database = getDatabase(app);

export { auth, database };
